import { render, staticRenderFns } from "./ResumeIntention.vue?vue&type=template&id=c138d41a&scoped=true"
import script from "./ResumeIntention.vue?vue&type=script&lang=js"
export * from "./ResumeIntention.vue?vue&type=script&lang=js"
import style0 from "./ResumeIntention.vue?vue&type=style&index=0&id=c138d41a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c138d41a",
  null
  
)

export default component.exports